// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   PROGRESS INDICATOR - G42 BRANDING
   ========================================== */

.progress-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--interview-space-sm);
  margin-bottom: 28px;
}

.progress-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--interview-radius-circle);
  background-color: var(--interview-border-light);
  transition: all var(--interview-transition-slow);
}

.progress-dot-active {
  background-color: var(--interview-brand-primary);
  width: 22px;
  border-radius: 5px;
}

.progress-dot-completed {
  background-color: var(--interview-success-border);
}
`, "",{"version":3,"sources":["webpack://./src/components/Interview/ProgressIndicator/ProgressIndicator.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6CAA6C;EAC7C,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":["/* ==========================================\n   PROGRESS INDICATOR - G42 BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n.progress-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--interview-space-sm);\n  margin-bottom: 28px;\n}\n\n.progress-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: var(--interview-radius-circle);\n  background-color: var(--interview-border-light);\n  transition: all var(--interview-transition-slow);\n}\n\n.progress-dot-active {\n  background-color: var(--interview-brand-primary);\n  width: 22px;\n  border-radius: 5px;\n}\n\n.progress-dot-completed {\n  background-color: var(--interview-success-border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
